/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Section, Footer } from '@tishman/components';
import React, { memo, useMemo } from 'react';
import invariant from 'invariant';
import { useStaticQuery, graphql } from 'gatsby';

import { useMenuLinkGroups } from './queries/useMenuLinkGroups';

import type { ComponentPropsWithoutRef } from 'react';
import type { MenuLink } from './queries';

// TODO : Fix images
const FOOTER_QUERY = graphql`
  query Footer {
    # footerLogo: image(relativePath: { eq: "tishman-logo.png" }) {
    #   fixed(width: 88, height: 46) {
    #     ...GatsbyImageSharpFixed_withWebp
    #   }
    # }
    dataJson(jsonId: { eq: "footer" }) {
      footerAppDownloadData {
        appStore {
          link
          image
        }
        googlePlay {
          link
          image
        }
      }
      footerContactData {
        address
        copyright
        phoneNumberOne
        phoneNumberTwo
      }
      footerFollowUsData {
        facebook
        instagram
        rocklistUrl
        twitter
      }
      subNavLinks {
        label
        url
      }
      footerContactSubNavLinks {
        label
        url
      }
    }
  }
`;

const FooterBlock = (
  props: ComponentPropsWithoutRef<typeof Section>,
): JSX.Element => {
  const { menuLinkGroups } = useMenuLinkGroups();
  // const { footerLogo, dataJson } =
  const { dataJson } = useStaticQuery<Queries.FooterQuery>(FOOTER_QUERY);
  // invariant(footerLogo, 'Footer logo is required!');
  invariant(dataJson, 'Footer JSON data is required!');

  const footerLogoData = useMemo(
    () => ({
      logo: `/assets/local-images/tishman-logo.png`,
      appStore: {
        link: dataJson.footerAppDownloadData.appStore.link,
        imageSrc: `/assets/local-images/${dataJson.footerAppDownloadData.appStore.image}`,
      },
      googlePlay: {
        link: dataJson.footerAppDownloadData.googlePlay.link,
        imageSrc: `/assets/local-images/${dataJson.footerAppDownloadData.googlePlay.image}`,
      },
    }),
    [dataJson],
  );

  return (
    <Section
      {...props}
      sx={{
        '@media print': {
          display: 'none',
        },
        'paddingBottom': ['50px', null, 'initial'],
      }}
      theme="Rock Center Black"
    >
      <Footer
        links={dataJson.subNavLinks as MenuLink[]}
        menuLinks={menuLinkGroups}
        {...footerLogoData}
        {...dataJson.footerContactData}
        footerContactSubNavLinks={
          dataJson.footerContactSubNavLinks as MenuLink[]
        }
        {...dataJson.footerFollowUsData}
      />
    </Section>
  );
};

export default memo(FooterBlock);
